<template>
  <div class="service-box" @scroll.passive="handleScroll($event)">
    <div class="tit-fixed">
      <div class="jarallax-container">
        <div class="cst_container_base">
          <h1>服务支持</h1>
          <h2></h2>
          <h3>SERVICE SUPPORT</h3>
        </div>
      </div>
      <div class="cst_textbox_line"></div>
    </div>   

    <div class="list-wrap">
      <div class="zhanwei"></div>
      <div class="wrap">
        <div class="service_box">
          <div class="tab">
            <el-collapse v-model="modelShow" accordion @change="handleChange">
              <el-collapse-item title="技术支持服务" name="7">
                <div class="smc_Area0">
                  <div class="smc_title" v-html="newsData7"></div>
                </div>
              </el-collapse-item>
              <el-collapse-item title="售后支持服务" name="8">
                <div class="smc_Area1">
                  <div class="smc_title" v-html="newsData8"></div>
                </div>
              </el-collapse-item>
            </el-collapse>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import News from '@/api/api.js'

export default {
  data() {
    return {
      isSticky: false, //是否吸顶
      modelShow: '7',
      newsData7: '',
      newsData8: '',
    };
  },
  created() {
    this.modelChange()
  },
  watch: {
   $route(to,from){
    this.modelChange()
   }
  },
  methods: {
    handleChange(val) {
      this.$router.push('/ServicePage?model='+ val);
    },
    modelChange() {
      this.modelShow = this.$route.query.model || '7'

      if(this['newsData'+this.modelShow]==''){
        this.$watch('newsData'+this.modelShow, this.addImgClass)
        this.getData(this.modelShow)
      }
    },
    async getData(classId){
      this.searchDTO = {
        classId  //新闻分类
      };
      let res = await News.getNewList(this.searchDTO);
      this['newsData'+classId] = res.data[0].content
    }
  }
};
</script>

<style lang="scss"  scoped >
/deep/ .el-collapse-item__header {
    font-size: 16px;
    font-weight: 600;
    color: #26a3de;
}
/deep/ .el-collapse-item__header i {
animation: turnSize .6s infinite linear;

}
@keyframes  turnSize{
  0%{
      transform:scale(1,1);
      -moz-transform:scale(1,1);
      -webkit-transform:scale(1,1);
      -o-transform:scale(1,1);
      -ms-transform:scale(1,1);
  }

  50%{
      transform:scale(1.5,1.5);
      -moz-transform:scale(1.5,1.5);
      -webkit-transform:scale(1.5,1.5);
      -o-transform:scale(1.5,1.5);
      -ms-transform:scale(1.5,1.5);
  }

  100%{
      transform:scale(1,1);
      -moz-transform:scale(1,1);
      -webkit-transform:scale(1,1);
      -o-transform:scale(1,1);
      -ms-transform:scale(1,1);
  }
}
.service-box {
  position: relative;

  background: linear-gradient(rgba(28, 69, 135, 0.7), rgb(32, 18, 77)),
    url("../../assets/image/news_bg.jpg") center center / cover no-repeat;
    background-attachment: fixed;

  &::-webkit-scrollbar {
    width: 2px;
  }
  &::-webkit-scrollbar-thumb {
    border-radius: 10px;
    // -webkit-box-shadow: inset 0 0 5px #99aeff;
    -webkit-box-shadow: inset 0 0 5px rgba(44, 65, 180, 0.5);
    background: #99aeff;
  }
  &::-webkit-scrollbar-track {
    // -webkit-box-shadow: inset 0 0 5px #99aeff;
    -webkit-box-shadow: inset 0 0 5px rgba(44, 65, 180, 0.5);
    border-radius: 0;
    background: rgba(0, 0, 0, 0.1);
  }
}
.list-wrap {
  // margin-top: 85px;
  //   padding-bottom: 85px;
  //   padding-top: 0px;
  //   background-color: rgb(7, 55, 99);
  //   min-height: 20px;
  //   height: 100%;
  .service_box {
    width: var(--base-width);
    margin: 0 auto;
    color: #fff;
    padding: 50px 0;
    // display: flex;
    // flex-flow: row wrap;
    // justify-content: space-between;
    @media screen and (min-width: 300px) and (max-width: 768px) {
      display: flex;
      flex-direction: column;
      width: calc(100% - 20px);
      padding: 50px 10px;
    }
    .tab {
      width: 100%;
      position: relative;
    }
    .tab ul {
      width: 150px;
      height: 50px;
      display: flex;
      flex-direction: column;
      margin-right: 20px;
      li {
        width: 150px;
        display: flex;
        box-sizing: border-box;
        padding: 0;
        line-height: 50px;
        list-style: none;
        text-align: center;
        // background: rgba(153, 0, 255, 0.5);
        background: #fff;
        color: #000;
        cursor: pointer;
        h2 {
          font-size: 16px;
          text-align: center;
          flex: 1;
        }
        .left_line {
          width: 10px;
          height: 50px;
          background: #fff;
        }
      }
    }

    .tab ul li.active .left_line {
      width: 10px;
      height: 50px;
      background: rgba(79, 20, 119, 0.8);
    }

    .smc_Area0 {
      background: #fff;
      border-radius: 10px;
      padding: 20px;
      line-height: 30px;
      color: #000;
      .smc_title {
        padding: auto;
        h1 {
          font-size: 18px;
        }
        p {
          font-size: 16px;
          margin: 20px 0;
          // text-indent: 2em;
        }
      }
      .smartImg0 {
        width: 60%;
        margin: 0 auto;
        img {
          width: 100%;
        }
      }
      .smartImg {
        width: 100%;
        img {
          width: 100%;
        }
      }
      span {
        // text-align: center;
        display: block;
        text-indent: 2em;
      }
      h2 {
        font-size: 18px;
        line-height: 50px;
      }
    }
    .smc_Area1 {
      background: #fff;
      border-radius: 10px;
      padding: 20px;
      line-height: 30px;
      color: #000;
      .smc_title {
        padding: auto;
        h1 {
          font-size: 18px;
        }
        p {
          font-size: 16px;
          margin: 20px 0;
        }
        span {
        // text-align: center;
        display: block;
        text-indent: 2em;
      }
      }
      .smartImg {
        width: var(--base-width);
        margin: 0 auto;
        img {
          width: 100%;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/view/webapp/ServicePage.vue